import { NoiseCatalogNumbersList } from "./noiseCatalogNumbersList";
import { ResultStatus } from "./resultStatus";
import { NoiseCatalogData } from "./noiseCatalogData";

export class FindOneNoiseCatalogNumberResponse {
    noiseCatalogData?: NoiseCatalogData;
    status?: ResultStatus;
}